import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottomtabsComponent } from './bottomtabs/bottomtabs.component';
import { AppRoutingModule } from '../app-routing.module';
import { MatBadgeModule } from '@angular/material/badge';



@NgModule({
  declarations: [
    BottomtabsComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MatBadgeModule
  ]
})
export class LayoutsModule { }
